import React, { useState } from "react";
import * as Yup from "yup";
import useLogin from "../../hooks/useLogin";
import { useNavigate } from "react-router-dom";
import { StyledCard, MainContainer, StyledInput, StyledLabel } from "./styles";
import { Button, Form } from "react-bootstrap";
import JogosLogo from "../../assets/logo/jogos-logo.png";

const validationSchema = Yup.object({
  username: Yup.string()
    .required("Este campo es requerido")
    .min(3, "Usuario debe tener al menos 3 caracteres")
    .max(360, "Usuario debe tener máximo 360 caracteres"),
  password: Yup.string()
    .required("Este campo es requerido")
    .min(3, "La contraseña debe tener al menos 3 caracteres")
    .max(100, "La contraseña debe tener máximo 100 caracteres"),
});

const Login: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [formValues, setFormValues] = useState({
    username: "",
    password: "",
  });
  const [formErrors, setFormErrors] = useState({
    username: "",
    password: "",
  });

  const { login } = useLogin();
  const navigate = useNavigate();

  const validateForm = async (): Promise<boolean> => {
    try {
      await validationSchema.validate(formValues, { abortEarly: false });
      setFormErrors({ username: "", password: "" });
      return true;
    } catch (err: any) {
      const validationErrors: any = {};
      err.inner.forEach((error: any) => {
        validationErrors[error.path] = error.message;
      });
      setFormErrors(validationErrors);
      return false;
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
  
    setIsLoading(true);
    setHasError(false);
  
    const isValid = await validateForm();
  
    if (!isValid) {
      setIsLoading(false);
      return;
    }
  
    try {
      const isSuccess = await login(formValues);
      if (!isSuccess) {
        setHasError(true);
        setIsLoading(false);
        return; 
      }
  
      navigate("/");
    } catch (error) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };
  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <MainContainer>
      <StyledCard style={{ width: "18rem" }}>
        <div className="text-center">
          <img src={JogosLogo} className="w-25 h-25" alt="Jogos Logo" />
        </div>

        {hasError && (
          <div className="alert alert-danger">
            Las credenciales son incorrectas
          </div>
        )}

        <form noValidate onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="username">
            <StyledLabel>Usuario</StyledLabel>
            <StyledInput
              type="text"
              name="username"
              placeholder="Usuario"
              value={formValues.username}
              onChange={handleChange}
              className={formErrors.username ? "is-invalid" : ""}
            />
            {formErrors.username && (
              <div className="invalid-feedback">{formErrors.username}</div>
            )}
          </Form.Group>

          <Form.Group className="mb-4" controlId="password">
            <StyledLabel>Contraseña</StyledLabel>
            <StyledInput
              type="password"
              name="password"
              placeholder="Contraseña"
              value={formValues.password}
              onChange={handleChange}
              className={formErrors.password ? "is-invalid" : ""}
            />
            {formErrors.password && (
              <div className="invalid-feedback">{formErrors.password}</div>
            )}
          </Form.Group>

          <div className="d-grid gap-2">
            <Button
              style={{ backgroundColor: '#262c47', fontSize: '.8125rem', border: '1px solid transparent'}}
              variant="primary"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Ingresando..." : "Ingresar"}
            </Button>
          </div>
        </form>
      </StyledCard>
    </MainContainer>
  );
};

export default Login;
